import { axiosInstance, baseUrl } from "./auth";
import { useQuery } from 'react-query'
import { ApiStatus } from "../constants";



export const  DOCUMENT_LIST = async (body) => {
    let response = await axiosInstance.post(`${baseUrl}/user/documentsList`, body)
    if (response.data.code !== ApiStatus.success) {
        throw new Error(response.data.message || ApiStatus.serverError)
    }
    return response.data
}

export const  DOCUMENT_ADD = async (body) => {
    let response = await axiosInstance.post(`${baseUrl}/user/addDocuments`, body)
    if (response.data.code !== ApiStatus.success) {
        throw new Error(response.data.message || ApiStatus.serverError)
    }
    return response.data
}


export const  DOCUMENT_UPDATE = async (body) => {
    let response = await axiosInstance.post(`${baseUrl}/user/updateDocuments`, body)
    if (response.data.code !== ApiStatus.success) {
        throw new Error(response.data.message || ApiStatus.serverError)
    }
    return response.data
}

export const  DOCUMENT_DELETE = async (body) => {
    let response = await axiosInstance.post(`${baseUrl}/user/toggleDeleteDoc`, body)
    if (response.data.code !== ApiStatus.success) {
        throw new Error(response.data.message || ApiStatus.serverError)
    }
    return response.data
}








